import { Box, Button, Card, Container, FormLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import InfoTooltip from '../components/InfoTooltip';

import {
  createBanner,
  createContactInfo,
  createShellySettings,
  createTwilioSettings,
  deleteUploads,
  getBanner,
  getContactInfo,
  getShellySettings,
  getTwilioSettings,
  uploadFile,
} from '../helper/backend_helper';
import appConfig from '../config';

// import logo from 'src/components/logo';

const TwilioSetting = () => {
  const [twilioSettingsData, setTwilioSettingsData] = useState({});

  const [accountID, setAccountID] = useState('');
  const [authToken, setAuthToken] = useState('');
  const [toPhone, setToPhone] = useState('');


  const [loading, setLoading] = useState(false);
 

  const Banner = async () => {
    try {
      const bannerResponse = await getTwilioSettings();
      console.log(bannerResponse.data.data);
      setTwilioSettingsData(bannerResponse?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);
  useEffect(() => {
    setAccountID(twilioSettingsData?.account_sid || '');
    setAuthToken(twilioSettingsData?.auth_token || '');
    setToPhone(twilioSettingsData?.toPhone || '');
  }, [twilioSettingsData]);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Check if any field is empty
      if (accountID.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Account ID cannot be empty',
        });
        setLoading(false);
        return;
      }

      if (authToken.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Auth Token cannot be empty',
        });
        setLoading(false);
        return;
      }
   
      if (toPhone.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Phone cannot be empty',
        });
        setLoading(false);
        return;
      }
   

     
      const BannerData = {
        account_sid: accountID,
        auth_token: authToken,
        toPhone
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createTwilioSettings(BannerData, Categoryheaders);

      // setTitle('');
      // setFormData({
      //   ...formData,
      //   profileImage: null,
      // });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Twilio Settings updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Twilio Settings',
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Twilio Settings </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          // onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="h4">Twilio Settings{' '}<InfoTooltip width={20} title="Holds the Twilio credentials Vesuview uses to send SMS notifications, such as alerts about bookings and check-ins. Enter your Twilio Account SID and Auth Token plus the destination phone number that should receive these messages. Update any field here and click Update to save the configuration." /></Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '60ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Account ID <InfoTooltip title="Your Twilio Account SID, found in the Twilio Console, used to identify the account that sends SMS messages." /></FormLabel>
              <TextField
                label="Enter Account ID"
                id="outlined-size-small"
                value={accountID}
                onChange={(e) => setAccountID(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Auth Token <InfoTooltip title="Secret Twilio auth token paired with the Account SID to authenticate API requests. Keep it confidential." /></FormLabel>
              <TextField
                label="Enter Auth Token"
                id="outlined-size-small"
                value={authToken}
                onChange={(e) => setAuthToken(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Phone Number <InfoTooltip title="Destination phone number (in international format) that receives Twilio SMS notifications from Vesuview." /></FormLabel>
              <TextField
                label="Enter Phone Number"
                id="outlined-size-small"
                value={toPhone}
                onChange={(e) => setToPhone(e.target.value)}
              />
            </Stack>
          </Stack>
        
        </Box>
        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default TwilioSetting;
